import Swiper, { Navigation, Pagination, Thumbs, Autoplay, EffectFade, EffectCreative, EffectCoverflow } from "swiper";
import EffectPanorama from '../effect-panorama.esm';
import matchHeight from "jquery-match-height";
import Videos from './video';

(function(window, document) {
  const slider = {
    init() {
      slider.create();
    },
    create() {
      if ($("[data-swiper-slider]").length) {
        $("[data-swiper-slider]").each(function() {
          const self = $(this);
          const id = self.attr("id");
          const _name = self.data("name");
          let _pagination = self.data("pagination");
          let options = self.data("options");
          if (_pagination != undefined) {
            _pagination = '.swiper-pagination[data-name="' + _name + '"]';
          } else {
            _pagination = null;
          }

          const slider = new Swiper(`#${id}`, {
            modules: [Navigation, Pagination, Thumbs, Autoplay, EffectFade, EffectCreative, EffectCoverflow, EffectPanorama],
            navigation: {
              nextEl: '[data-slider-next][data-name="' + _name + '"]',
              prevEl: '[data-slider-prev][data-name="' + _name + '"]',
            },
            pagination: {
              el: _pagination,
              clickable: true,
              renderBullet: function(index, className) {
                return (
                  '<span class="' + className + '">' + (index + 1) + "</span>"
                );
              },
            },
            on: {
              init: function(s) {

                if (_name == 'our-services') {
                  let slidePrev = null;
                  let slideNext = null;
                  let isMoving = false;

                  const totalSlides = s.$el.find('[data-our-services-item]').length;

                  s.on('transitionEnd', function() {
                    isMoving = false;
                  });

                  $('body').on('mouseenter', '.panel-our-services [data-our-services-item]', function(event) {
                    const currentSlide = event.target.closest('.swiper-slide');
                    let num = currentSlide.getAttribute('data-swiper-slide-index') || s.slides.indexOf(currentSlide);

                    $('[data-tab-group].w-our-services [data-tab-content]').eq(parseInt(num)).addClass('on').siblings().removeClass('on');
                  });

                  $('body').on('mouseenter', '.panel-our-services .box-our-services-top', function(event) {
                    if (slidePrev == null && !isMoving) {
                      isMoving = true;
                      s.slidePrev(600);
                      slidePrev = setInterval(function() {
                        if (totalSlides > (s.realIndex + 7) && !isMoving) {
                          isMoving = true;
                          s.slidePrev(600);
                        }
                      }, 700);
                    }
                  });

                  $('body').on('mouseleave', '.panel-our-services .box-our-services-top', function(event) {
                    clearInterval(slidePrev);
                    slidePrev = null;
                    setTimeout(function() {
                      isMoving = false;
                    }, 600);
                  });

                  $('body').on('mouseenter', '.panel-our-services .box-our-services-bottom', function(event) {
                    if (slideNext == null && !isMoving) {
                      isMoving = true;
                      s.slideNext(600);
                      slideNext = setInterval(function() {
                        if (totalSlides > (s.realIndex + 7) && !isMoving) {
                          isMoving = true;
                          s.slideNext(600);
                        }
                      }, 700);
                    }
                  });

                  $('body').on('mouseleave', '.panel-our-services .box-our-services-bottom', function(event) {
                    clearInterval(slideNext);
                    slideNext = null;
                    setTimeout(function() {
                      isMoving = false;
                    }, 600);
                  });

                  $('body').on('mouseleave', '.panel-our-services [data-ele-hover-group]', function(event) {
                    $('[data-tab-group].w-our-services [data-tab-content]').eq(s.realIndex).addClass('on').siblings().removeClass('on');
                    clearInterval(slideNext);
                    clearInterval(slidePrev);
                    slidePrev = null;
                    slideNext = null;
                    isMoving = false;
                  });

                }

                if (self.hasClass('w-switch-country')) {
                  $('body').on('mouseenter', '[data-switch-country-item]', function(event) {
                    let n = $(this).parent().attr('data-swiper-slide-index');
                    $('[data-swiper-tab-content].country-item').eq(n).addClass('on').siblings().removeClass('on');
                  });
                }

                if (_name == 'feature') {
                  checkEqualHeight();

                  setTimeout(function() {
                    checkEqualHeight()
                  }, 300);
                }

                if (_name == 'why-choose-us') {
                  checkEqualHeightOp2();

                  setTimeout(function() {
                    checkEqualHeightOp2()
                  }, 300);
                }

                if (_name == 'introduction') {
                  checkEqualHeightOp3();

                  setTimeout(function() {
                    checkEqualHeightOp3()
                  }, 300);
                }

                if (self.is('[data-autoplay="ipad"]')) {

                  setTimeout(function() {
                    if (self.hasClass('swiper-initialized')) {
                      if ($(window).width() < 768) {
                        slider.autoplay.stop();
                        slider.slideTo(0, 0);
                      }
                    }
                  }, 300);

                  self.hover(function() {

                    if ($(window).width() > 767) {}

                  }, function() {});

                  self.on('mouseleave', function(event) {
                    if ($(window).width() > 767) {
                      slider.autoplay.start();
                    }
                  });
                }

                setTimeout(function() {
                  const destroy = self.data('destroy');
                  if (destroy && self.hasClass('swiper-initialized')) {
                    switch (destroy) {
                      case 'mobile':
                        if ($(window).width() < 768) {
                          slider.disable();
                        } else {
                          slider.enable();
                        }
                        break;
                      case 'ipad':
                        if ($(window).width() >= 768) {
                          slider.disable();
                        } else {
                          slider.enable();
                        }
                    }
                  }

                  if (_name == 'why-choose-us') {
                    var _slHeight = self.find('.swiper-slide').not('.swiper-slide-active').first().find('.box').outerHeight(true) + 47;
                    self.parent().find('.ctr').css('top', _slHeight);

                    if (self.parent().find('.swiper-button-disabled').length === 2) {
                      self.parent().find('.ctr').stop().hide();
                    } else {
                      self.parent().find('.ctr').stop().show();
                    }
                  }

                  s ? .update();
                }, 300);

                setTimeout(function() {
                  if (_name == 'why-choose-us') {
                    var _slHeight = self.find('.swiper-slide').not('.swiper-slide-active').first().find('.box').outerHeight(true) + 47;
                    self.parent().find('.ctr').css('top', _slHeight);
                  }

                  s ? .update();
                }, 1000);

                $(window).on('resize', function(event) {
                  if (_name == 'why-choose-us') {
                    var _slHeight = self.find('.swiper-slide').not('.swiper-slide-active').first().find('.box').outerHeight(true) + 47;
                    self.parent().find('.ctr').css('top', _slHeight);

                    if (self.parent().find('.swiper-button-disabled').length === 2) {
                      self.parent().find('.ctr').stop().hide();
                    } else {
                      self.parent().find('.ctr').stop().show();
                    }
                  }
                });

                if (_name === 'slider-histories') {
                  const w = $(window).width();

                  $('.histories-timeline li').removeClass('active');
                  $('.histories-timeline li').eq(s ? .realIndex).addClass('active');
                  let spacingPadding = w > 1024 ? 20 : 32;
                  if (w < 768) {
                    spacingPadding = -10;
                  }
                  const spacingLeft = $(window).width() - $('.panel.panel-histories [data-row]').width() - spacingPadding;
                  const wItem = w > 1024 ? 165 : 80;
                  $('.line').stop().animate({
                    left: (s ? .realIndex * wItem) + spacingLeft,
                  });
                  $('.histories-timeline').animate({
                    scrollLeft: ((s ? .realIndex - 1) * wItem) + spacingLeft,
                    behavior: 'smooth'
                  });
                }

                if (_name == 'feature') {
                  const _activeIndex = s.activeIndex;
                  self.find('.swiper-slide').eq(_activeIndex).addClass('img-animated').siblings().removeClass('img-animated');
                }
              },
              breakpoint: function() {
                if (self.is('[data-autoplay="ipad"]') && self.hasClass('swiper-initialized')) {
                  if ($(window).width() < 768) {
                    slider.autoplay.stop();
                    slider.slideTo(0, 0);
                  } else {
                    slider.autoplay.start();
                  }
                }

                const destroy = self.data('destroy');
                if (destroy && self.hasClass('swiper-initialized')) {
                  switch (destroy) {
                    case 'mobile':
                      if ($(window).width() < 768) {
                        slider.disable();
                      } else {
                        slider.enable();
                      }
                      break;
                    case 'ipad':
                      if ($(window).width() >= 768) {
                        slider.disable();
                      } else {
                        slider.enable();
                      }
                      break;
                  }
                }

                if (_name == 'why-choose-us') {
                  var _slHeight = self.find('.swiper-slide').not('.swiper-slide-active').first().find('.box').outerHeight(true) + 47;
                  self.parent().find('.ctr').css('top', _slHeight);
                }
              },
              transitionEnd: function(s) {

                if (_name == 'feature') {
                  const _videos = new Videos();
                  let _prefix = 0;
                  let _video = null;

                  self.find('[data-video-element]:visible').each(function(index, el) {
                    if ($(this).parent().hasClass('swiper-slide-active')) {
                      _prefix = $(this).data('prefix');
                      _video = _videos.getVideo(_prefix);
                      if (_video) {
                        _video.value.play();
                      }
                    } else {
                      _prefix = $(this).data('prefix');
                      _video = _videos.getVideo(_prefix);
                      if (_video) {
                        _video.value.pause();
                      }
                    }
                  });

                  const _activeIndex = slider.activeIndex;
                  self.find('.swiper-slide').eq(_activeIndex).addClass('img-animated').siblings().removeClass('img-animated');
                }

                if (_name == 'why-choose-us') {
                  setTimeout(function() {
                    var _slHeight = self.find('.swiper-slide').not('.swiper-slide-active').first().find('.box').outerHeight(true) + 47;
                    self.parent().find('.ctr').css('top', _slHeight);

                    s ? .update();
                  }, 100);
                }
              },
              slideChange: function(s) {

                if (_name === 'slider-histories') {
                  const w = $(window).width();

                  $('.histories-timeline li').removeClass('active');
                  $('.histories-timeline li').eq(s ? .realIndex).addClass('active');
                  let spacingPadding = w > 1024 ? 20 : 32;
                  if (w < 768) {
                    spacingPadding = -3;
                  }
                  const spacingLeft = $(window).width() - $('.panel.panel-histories [data-row]').width() - spacingPadding;
                  const wItem = w > 1024 ? 165 : 80;
                  $('.line').stop().animate({
                    left: (s ? .realIndex * wItem) + spacingLeft
                  });
                  $('.histories-timeline').animate({
                    scrollLeft: ((s ? .realIndex - 1) * wItem) + spacingLeft,
                    behavior: 'smooth'
                  });
                }
              },
              activeIndexChange: (s) => {
                if (_name === 'introduction') {
                  var tabname = $(s.slides[s.activeIndex]).find('.tab-item').data('name');
                  if ($('[data-tab-content][data-name="' + tabname + '"]').hasClass('w-dropdown')) {
                    $('[data-tab-content][data-name="' + tabname + '"]').addClass('on').parents('[data-dropdown]').siblings().find('[data-tab-content]').removeClass('on');
                  } else {
                    $('[data-tab-content][data-name="' + tabname + '"]').addClass('on').siblings().removeClass('on');
                  }
                }
              },
              realIndexChange: (s) => {
                if (self.hasClass('w-switch-country')) {
                  $('[data-swiper-tab-content].country-item').eq(s.realIndex).addClass('on').siblings().removeClass('on');
                }

                if (_name == 'our-services') {
                  $('[data-tab-group].w-our-services [data-tab-content]').eq(s.realIndex).addClass('on').siblings().removeClass('on');
                }
              }
            },
            ...options,
          });

          if (self.hasClass('w-message')) {
            let autoplayEnabled = true;

            self.on('mouseenter', function() {
              autoplayEnabled = false;
              slider.autoplay.stop();
              slider.allowSlideNext = false;
              slider.allowSlidePrev = false;
            });

            self.on('mouseleave', function() {
              autoplayEnabled = true;
              slider.autoplay.start();
              slider.allowSlideNext = true;
              slider.allowSlidePrev = true;
            });
          }

          function updateNumberSlides() {
            var slides = self.find('.swiper-slide');
            var middle = self.find('.swiper-slide-active').index();
            slides.each(function(i) {
              $(this).attr('data-num', Math.abs(i - middle));
            });
          }


          function checkEqualHeight() {
            self.find('[data-text]').matchHeight({
              byRow: true,
              property: 'height',
              target: null,
              remove: false
            });
          }

          function checkEqualHeightOp2() {
            self.find('[data-box-wrap]').matchHeight({
              byRow: false,
              property: 'height',
              target: null,
              remove: false
            });
          }

          function checkEqualHeightOp3() {
            self.find('[data-introduction-item]').matchHeight({
              byRow: false,
              property: 'height',
              target: null,
              remove: false
            });
          }

          $('body').on('click', '[data-nav-slider]', function(event) {
            event.preventDefault();
            $(this).addClass("on").parent().siblings().find('[data-nav-slider]').removeClass("on");
            let _n = $(this).data('name');
            if (_n == _name) {
              let _index = $(this).parent().index();
              slider.slideTo(_index, 1000);
            }
          });
        });
      }
    },
  };

  window.jQuery(document).ready(function() {
    slider.init();

    $('[data-equal-height-title]').matchHeight({
      byRow: false,
      property: 'height',
      target: null,
      remove: false
    });
  });
})(window, document);